import * as yup from 'yup';

export const validationSchema = () => 
  yup.object({
    simSerialNumber: yup.string()
    .min(19, 'Dev’essere composto da 19 numeri')
    .max(19, 'Dev’essere composto da 19 numeri')
    .matches(/^[0-9]{19}/, 'Dev’essere composto da 19 numeri'),
  });
